import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import Notification from './Notification/Notification';
import './Login.css';

const apiUrl = process.env.REACT_APP_API_URL;

function Login({ onLogin }) {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(true);
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({ message: '', type: '' });
  const navigate = useNavigate();

  const showNotification = (message, type) => setNotification({ message, type });

  const handleSubmit = async (e) => {
    
    e.preventDefault();
    if (!name || !password) {
      showNotification('Please enter username and password', 'error');
      return;
    }
    setLoading(true);
    setNotification({ message: '', type: '' });
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      localStorage.removeItem('level');
      localStorage.removeItem('id');

      const res = await fetch(`${apiUrl}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, password }),
      });

      const userData = await res.json();
      if (res.ok) {
        localStorage.setItem('token', userData.token);
        localStorage.setItem('userData', userData.fullname);
        localStorage.setItem('level', userData.level);
        localStorage.setItem('id', userData.id);
        if (remember) localStorage.setItem('remember', '1');

        await new Promise((resolve) => setTimeout(resolve, 0));

        onLogin && onLogin(userData);

        if (userData.firstLogin) {
          navigate('/change-password');
        } else {
          navigate('/', { state: { message: 'Bejelentkezés sikeres!', type: 'success' } });
        }
      } else {
        showNotification(userData.message || 'Login failed', 'error');
      }
    } catch (err) {
      
      showNotification(err.message || 'Network error', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-root">
      <div className="login-backdrop" />
      <div className="login-card">
        <div className="login-brand">
          <img src={process.env.PUBLIC_URL + '/logo192.png'} alt="logo" className="login-logo" />
          <h2>Kajimoka Media</h2>
          <p className="muted">Manage your media quickly and securely</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Username</label>
            <input
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter username"
              autoFocus
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              className="form-control"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              disabled={loading}
            />
          </div>

          <div className="form-row between">
            <label className="remember">
              <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} disabled={loading} /> Remember me
            </label>
            <a className="link-muted" href="#/forgot">Forgot?</a>
          </div>

          <button className={`btn btn-primary btn-block ${loading ? 'loading' : ''}`} type="submit" disabled={loading}>
            {loading ? <span className="btn-spinner" /> : 'Sign in'}
          </button>
        </form>

        <div className="login-footer">
          <small>Need an account? Ask your administrator.</small>
        </div>

        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification({ message: '', type: '' })}
        />
      </div>
    </div>
  );
}

export default Login;
